/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".text-container[_ngcontent-%COMP%]{position:relative;width:92%;left:10%;top:-25px;word-break:break-word}\n/*# sourceMappingURL=custom-snackbar.component.css.map*/"];
export { styles as styles };
